import { render, staticRenderFns } from "./MaterialAddDialog.vue?vue&type=template&id=0a22981c&scoped=true"
import script from "./MaterialAddDialog.vue?vue&type=script&lang=js"
export * from "./MaterialAddDialog.vue?vue&type=script&lang=js"
import style0 from "./MaterialAddDialog.vue?vue&type=style&index=0&id=0a22981c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a22981c",
  null
  
)

export default component.exports